import {appContainer} from "../contexts/app";
import {deleteInState, fromImmutable, hydrateParent, setInState, setListInState, toImmutable, validate} from "./hooks";
import FloorRecordFactory from "./floor-record";

const hydrateBuilding = hydrateParent("api/buildings", "building_id");

export default app => {
  const service = app.service("api/floors");
  // Lengthen the timeout to allow for image uploads
  service.timeout = 20000;

  const FloorRecord = FloorRecordFactory(service);

  appContainer.FloorRecord = FloorRecord;
  app.set("FloorRecord", FloorRecord);

  const validateFloor = validate({
    name: "Floor name is required.",
    "overlay.image.path": "An image is required."
  });

  service.hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [fromImmutable, validateFloor],
      update: [fromImmutable, validateFloor],
      patch: [fromImmutable, validateFloor],
      remove: []
    },

    after: {
      all: [toImmutable(FloorRecord)],
      find: [setListInState("floors")],
      get: [setInState("floors")],
      create: [setInState("floors"), hydrateBuilding],
      update: [setInState("floors")],
      patch: [setInState("floors")],
      remove: [deleteInState("floors"), hydrateBuilding]
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};



// WEBPACK FOOTER //
// ./src/feathers/floors.js